import React from 'react';

import {UserLink} from 'src/components/links';
import {getUserLabel} from 'src/utils/getUserLabel';

import type {UserShortInfo} from 'src/openapi/admin/models/UserShortInfo';

type Props = {
    user: UserShortInfo,
};

export const EmailInitiatorCell = ({user}: Props) => {
    return user ? (
        <UserLink
            userId={user.userId}
            caption={getUserLabel(user)}
            place="Account Entitlements Change Log"
        />
    ) : null;
};
